<template>
  <div id="source-manage" v-loading="loading">
    <!-- 左边树结构 -->
    <div class="left_tree_box drag-left-layout">
      <el-radio-group v-model="treeType" size="small" class="ml-5 tree-tabs-wrapper">
        <el-radio-button label="WEB"></el-radio-button>
        <el-radio-button label="APP"></el-radio-button>
      </el-radio-group>
      <div class="ml-4 mr-4 mt-1">
        <el-input
          v-model="searchText"
          class="self-filter-input"
          size="small"
          placeholder="搜索"
          @keyup.enter.native="filterTree"
        >
          <i slot="suffix" @click="filterTree">
            <svg-icon icon-class="input_search"></svg-icon>
          </i>
        </el-input>
      </div>

      <span class="vertical-bar fnM ml-5">资源结构</span>
      <el-tree
        ref="resourceTree"
        class="self-tree data_tree"
        node-key="id"
        :props="defaultProps"
        :data="treeData"
        :highlight-current="true"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultShowNodes"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
      >
        <span slot-scope="{ node }" :title="node.label" class="self-custom-tree">
          <span :class="node.isCurrent ? '' : node.data.resourceType === 'RESOURCE' ? 'text-blue-3377' : ''">
            <svg-icon v-if="node.data.icon" :icon-class="node.data.icon" class="mr-1"></svg-icon>
            <span v-html="handleFilter(node.label)"></span>
          </span>
          <el-dropdown
            v-if="node.data.resourceType !== 'DIRECTORY'"
            trigger="hover"
            @command="
              com => {
                treeCommand(com, node.data);
              }
            "
          >
            <i class="el-icon-more"></i>
            <el-dropdown-menu slot="dropdown" :visible-arrow="false" class="resource_popover">
              <el-dropdown-item command="add" class="green_hover">
                <span>{{ $t('public.addTo') }}{{ $t('dataPermission.source') }}</span>
              </el-dropdown-item>
              <el-dropdown-item v-if="node.data.resourceType === 'RESOURCE'" command="edit">
                <span>{{ $t('public.edit') }}</span>
              </el-dropdown-item>
              <el-dropdown-item
                v-if="node.data.resourceType === 'RESOURCE'"
                command="delete"
                class="delete_hover"
              >
                <span>{{ $t('public.delete') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </el-tree>
      <!-- 添加/编辑 -->
      <el-dialog
        v-dialogDrag
        :title="dialogAdd ? '添加资源' : '编辑资源'"
        class="source_dialog code_source_dialog"
        :visible.sync="sourceVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
      >
        <el-row>
          <el-col :span="10">
            <el-form ref="resourceForm" size="small" :model="formData" :rules="formRules">
              <el-form-item label="资源名称" prop="resourceName">
                <el-input v-model="formData.resourceName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="资源编码" prop="resourceCode">
                <el-input v-model="formData.resourceCode" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="排序(升序)" prop="sort">
                <el-input v-model="formData.sort" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="描述" prop="remark">
                <el-input
                  v-model="formData.remark"
                  placeholder="请输入描述信息，限50字以内"
                  type="textarea"
                  :rows="4"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="14" class="design-json">
            <code-mirror-editor v-model="jsonValue"></code-mirror-editor>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button plain size="small" @click="sourceVisible = false">
            {{ $t('public.cancel') }}
          </el-button>
          <el-button type="primary" size="small" @click="handleSubmit">
            {{ $t('public.confirm') }}
          </el-button>
        </div>
      </el-dialog>
      <!-- 删除 -->
      <el-dialog v-dialogDrag :visible.sync="deleteVisible" class="delete_dialog">
        <div class="warning_title fnM fn16">
          <svg-icon class="before_icon" icon-class="dialog_warning"></svg-icon>
          确认要删除资源结构“{{ formData.resourceName }}”吗？
        </div>
        <p v-if="formData.children && formData.children.length > 0" class="delete_tips">
          该资源结构内含有子项，不能被删除！
        </p>
        <p v-else class="delete_tips">如果该结构有关联的资源，删除后将无法恢复。</p>

        <div slot="footer" class="dialog-footer">
          <div v-if="formData.children && formData.children.length > 0">
            <el-button type="primary" size="small" @click="deleteVisible = false">知道了</el-button>
          </div>

          <div v-else>
            <el-button plain @click="deleteVisible = false">{{ $t('public.cancel') }}</el-button>
            <el-button type="danger" @click="deleteTreeItem">{{ $t('public.confirm') }}</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="right_content" v-if="currentNode && currentNode.resourceType !== 'RESOURCE'">
      <div class="top_info_box">
        <span class="vertical-bar fn18 fnM">{{ currentNode.resourceName }}</span>
        <div class="detail_box">
          <div class="detail_resource_path">
            菜单编码：
            <span v-if="currentNode.resourceCode">{{ currentNode.resourceCode }}</span>
            <span v-else class="empty_description">暂无</span>
          </div>
          <div class="detail_sort">排序：{{ currentNode.sort }}</div>
        </div>
      </div>
      <div class="split_bar"></div>
    </div>
    <!--  右边内容 -->
    <div class="right_content" v-if="currentNode && currentNode.resourceType === 'RESOURCE'">
      <div class="top_info_box">
        <span class="vertical-bar fn18 fnM">{{ detailInfo.resourceName }}</span>
        <div class="detail_box">
          <div class="detail_resource_path">
            资源编码：
            <span v-if="detailInfo.resourceCode">{{ detailInfo.resourceCode }}</span>
            <span v-else class="empty_description">暂无</span>
          </div>
          <div class="detail_sort">排序：{{ detailInfo.sort }}</div>
        </div>
        <div class="detail_box">
          <div class="detail_resource_path">
            描述：
            <span v-if="detailInfo.remark">{{ detailInfo.remark }}</span>
            <span v-else class="empty_description">暂无</span>
          </div>
          <div>
            <el-button size="small" type="primary" @click="handleAnalysis(detailInfo)">
              解析资源
            </el-button>
          </div>
        </div>
      </div>

      <template v-for="(com,index) in configEditorModal.enableComList">
        <div class="split_bar"></div>
        <div class="table_content">
          <template v-if="com.type==='rc-search-form'">
            <searchCom :com.sync="com"></searchCom>
          </template>
          <template v-if="com.type==='tabs'">
            <tabCom :com.sync="com"></tabCom>
          </template>
          <template v-if="com.type==='configurable-general-table'">
            <datatableCom :com.sync="com"></datatableCom>
          </template>
          <template v-if="com.type==='rc-form'">
            <formCom :com.sync="com"></formCom>
          </template>
          <template v-if="com.type==='resources'">
            <resourcesCom :com.sync="com" @onRowSave="onResourceRowSave"></resourcesCom>
          </template>
        </div>
      </template>

      <!--<div class="split_bar"></div>
      <div class="table_content">
        <div style="position: sticky; top: 0">
          <div class="search_box">
            <span class="vertical-bar fn18 fnM" style="line-height: 32px">资源列表</span>
            <div class="search_btn">
              <el-input
                v-model="tableSearch"
                size="small"
                placeholder="请输入关键字"
                style="width: 303px; margin-right: 8px"
                clearable
                @clear="getDetailList"
                @keyup.enter.native="getDetailList"
              >
                <i slot="suffix" style="padding-right: 8px" @click="getDetailList">
                  <svg-icon icon-class="input_search"></svg-icon>
                </i>
              </el-input>
              <el-button
                v-if="tableData.length != 0 && isSchema"
                size="small"
                style="width: 80px; margin-right: 10px; margin-left: 0"
                type="primary"
                @click="saveSource"
              >
                保存
              </el-button>
              <el-button size="small" type="primary" @click="handleAnalysis(detailInfo)">
                解析资源
              </el-button>
            </div>
          </div>

          <div class="small_table">
            <customTable order height="500px" :table-data="tableData" :show-pagination="false">
              <el-table-column prop="resourceElementLabel" label="资源名称">
                <template slot-scope="scope">
                  {{ $t(scope.row.resourceElementLabel) }}
                </template>
              </el-table-column>
              <el-table-column label="自定义名称">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.resourceElementExtendLabel"
                    class="self-filter-input"
                    size="small"
                    placeholder="请输入"
                  ></el-input>
                  &lt;!&ndash; <span v-if="!editState">{{ scope.row.resourceElementExtendLabel }}</span> &ndash;&gt;
                </template>
              </el-table-column>
              <el-table-column
                prop="resourceElementCode"
                label="资源标识"
                width="120"
                show-overflow-tooltip
              />
              <el-table-column
                prop="resourceStructureTypeDesc"
                width="120"
                label="类型"
              ></el-table-column>
            </customTable>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import resourceApi from "@/api/data-permission/dataPermission";
import CodeMirrorEditor from "@/components/common/CodeMirror";
import { commonFilterNode } from "@/utils";
import { Message } from "element-ui";
import searchCom from "../configEditor/search";
import datatableCom from "../configEditor/datatable";
import formCom from "../configEditor/form";
import tabCom from "../configEditor/tab";
import parser from "@/utils/parser";
import resourcesCom from "../configEditor/resources";

export default {
  name: "PageConfig",
  components: {CodeMirrorEditor, searchCom, datatableCom, formCom, tabCom, resourcesCom},
  provide() {
    return {
      saveConfig: this.saveConfig,
      getResourceConfigCopy: this.getResourceConfigCopy
    };
  },
  props: {},
  data() {
    return {
      configEditorModal: {
        enableComList: []
      },

      jsonValue: "",
      loading: false,
      isSchema: true,
      searchText: "",
      filterText: "",
      formData: {},
      formRules: {
        resourceName: [{ required: true, message: "资源名称不能为空", trigger: "blur" }],
        resourcePath: [{ required: true, message: "资源路径不能为空", trigger: "blur" }],
        resourceCode: [{ required: true, message: "资源编码不能为空", trigger: "blur" }]
      },
      dialogAdd: true,
      sourceVisible: false,
      deleteVisible: false,
      treeData: [],
      defaultShowNodes: [],
      currentNode: null,
      defaultProps: {
        children: "children",
        label: "resourceName"
      },
      detailInfo: {},
      tableSearch: "",
      tableData: [],
      treeType: "WEB"
    };
  },
  watch: {
    sourceVisible(val) {
      if (!val) {
        this.formData = {};
        this.$refs.resourceForm.clearValidate();
      }
    },
    treeType() {
      this.centerSearchText = "";
      this.currentNode = null;
      this.detailInfo = {};
      this.getTreeList();
    }
  },
  created() {
    this.getTreeList();
  },
  methods: {
    handleTreeData(children) {
      children.forEach(element => {
        const { resourceType } = element;
        element.icon = resourceType === "DIRECTORY" ? "icon_floder" : resourceType === "MENU" ? "icon_menu" : "";
        if (element.children) {
          this.handleTreeData(element.children);
        }
      });
    },
    //  获取树资源
    getTreeList() {
      resourceApi.getResourceTree({ parseToTree: true, clientType: this.treeType }).then(res => {
        this.handleTreeData(res.data);
        this.treeData = res.data;

        this.$nextTick(() => {
          if (!this.currentNode) {
            const [node] = this.treeData;
            this.currentNode = node;
            this.defaultShowNodes.push(node.id);
          }

          this.$refs.resourceTree && this.$refs.resourceTree.setCurrentKey(this.currentNode.id);

          // 资源
          if (this.currentNode && this.currentNode.resourceType === "RESOURCE") {
            this.getResourceDetail();
            this.getDetailList();
          }
        });
      });
    },
    // 手动高亮筛选文本
    handleFilter(str) {
      if (!this.filterText || !str) {
        return str;
      }
      const index = str.indexOf(this.filterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.filterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.filterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    // 筛选树
    filterTree() {
      this.filterText = this.searchText;
      this.$refs.resourceTree.filter(this.searchText);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },
    // 节点点击
    handleNodeClick(node) {
      this.currentNode = node;
      if (this.currentNode.resourceType === "RESOURCE") {
        this.getDetailList();
        this.getResourceDetail();
      }
    },
    // 树元素点击
    treeCommand(com, data) {
      this.formData = {};
      if (com === "add") {
        this.formData.parentId = data.id;
        this.formData.menuId = data.menuId;
        this.jsonValue = "";
        this.dialogAdd = true;
        this.sourceVisible = true;
      }
      if (com === "edit") {
        // eslint-disable-next-line no-unused-vars
        const { children, ...obj } = data;
        this.formData = obj;
        this.jsonValue = data.content || "";
        this.dialogAdd = false;
        this.sourceVisible = true;
      }
      if (com === "delete") {
        this.formData = data;
        this.deleteVisible = true;
      }
    },
    // 表单提交
    handleSubmit() {
      this.$refs.resourceForm.validate(valid => {
        if (valid) {
          const json = this.jsonValue;

          if (json.includes("WEBPACK_IMPORTED_MODULE")) {
            this.$message.error("JSON格式不正确，包含模块引用(WEBPACK_IMPORTED_MODULE)！");
            return;
          }

          if (json.includes("this")) {
            this.$message.error("JSON格式不正确，包含this！");
            return;
          }

          if (this.dialogAdd) {
            resourceApi
              .addResource({ ...this.formData, clientType: this.treeType, content: json })
              .then(res => {
                Message.success("添加成功");
                this.sourceVisible = false;
                this.getTreeList();
              });
          } else {
            resourceApi.editResource({ ...this.formData, content: json }).then(res => {
              Message.success("修改成功");
              this.sourceVisible = false;
              this.getTreeList();
            });
          }
        }
      });
    },
    // 删除
    deleteTreeItem() {
      resourceApi
        .deleteResourceById(this.formData.id)
        .then(res => {
          Message.success("删除成功");
          this.formData = {};
          if (this.currentNode.id === this.formData.id) {
            this.currentNode = null;
          }
          this.deleteVisible = false;
          this.getTreeList();
        })
        .catch(() => {
          this.formData = {};
        });
    },
    // 获取节点详情
    getResourceDetail() {
      // this.currentNode.id  "1461278252017610752"
      resourceApi.getResourceDetailById(this.currentNode.id).then(res => {
        if (res.data) {
          this.detailInfo = res.data;
          this.jsonValue = res.data.content || "";
          this.configEditorLoad();
        } else {
          this.detailInfo = {};
        }
      });
    },
    // 获取资源列表
    getDetailList() {
      resourceApi.getResourceList(this.currentNode.id, { search: this.tableSearch }).then(res => {
        this.tableData = res.data;
      });
    },
    // 解析资源
    handleAnalysis(data) {
      const { resourceCode } = data;
      if (!resourceCode) {
        return;
      }

      // this.loading = true;
      resourceApi.analysisToResource(resourceCode).then(() => {
        this.getDetailList();
      });
    },
    saveSource() {
      resourceApi.saveResource(this.currentNode.id, this.tableData).then(() => {
        this.getDetailList();
        this.getResourceDetail();
        Message.success("已保存");
        this.handleAnalysis(this.detailInfo);
      });
    },

    configEditorLoad(config = this.detailInfo.content) {
      const configObj = JSON.parse(config);

      this.configEditorModal.enableComList.length = 0;

      const findEnableCom = (nodes) => {
        nodes.forEach(node => {
          if (node.id && node.componentName) {
            this.configEditorModal.enableComList.push({id: node.id, type: node.componentName});
          }

          if (node.children && node.children.length > 0) { findEnableCom(node.children); }
        });
      };

      findEnableCom(configObj.bodyConfig);

      this.configEditorModal.enableComList.forEach(com => {
        com.config = configObj.componentAttributesMap[com.id];
      });

      const setResolvedResourcesInConfig = () => {
        const resolvedResourcesInConfig = configObj.resources.forEach(res => {
          res.rsData = this.tableData.find(data => data.resourceElementCode === res.rsKey);
        });
        if (configObj.resources && configObj.resources.length > 0) {
          this.configEditorModal.enableComList.push({
            id: "resources",
            type: "resources",
            config: {items: configObj.resources}
          });
        }
      };

      if (configObj.resources && configObj.resources.length > 0) {
        resourceApi.getResourceList(this.currentNode.id, { search: this.tableSearch }).then(res => {
          if (res.data && res.data.length > 0) {
            this.tableData = res.data;
            setResolvedResourcesInConfig();
          } else { //Resource not analysed
            const {resourceCode} = this.detailInfo;
            if (!resourceCode) {
              return;
            }

            resourceApi.analysisToResource(resourceCode).then(() => {
              resourceApi.getResourceList(this.currentNode.id, {search: this.tableSearch}).then(res => {
                this.tableData = res.data;
                setResolvedResourcesInConfig();
              });
            });
          }
        });
      }
    },

    configEditorSubmit() {
      resourceApi.editResource({...this.formData, content: json}).then(res => {
        Message.success("修改成功");
        this.sourceVisible = false;
        this.getTreeList();
      });
    },

    getResourceConfigCopy(){
      if (this.detailInfo){
        return parser.parse(this.detailInfo.content);
      }
    },

    saveConfig({content, succCallback, failedCallback}) {
      const resourceDataCopy = JSON.parse(JSON.stringify(this.detailInfo));
      delete resourceDataCopy.children;
      resourceDataCopy.content = content;
      resourceApi.editResource({...resourceDataCopy}).then(res => {
        succCallback();
        this.getResourceDetail();
      }).catch(e => {
        failedCallback(e);
      });
    },

    onResourceRowSave({rsDataCopy, afterSourceSave}) {
      const dataNeedUpdate = this.tableData.find(data => data.resourceElementCode === rsDataCopy.resourceElementCode);
      dataNeedUpdate.defaultPermission = rsDataCopy.defaultPermission;
      //step 1: save resource
      resourceApi.saveResource(this.currentNode.id, this.tableData).then(() => {
        const { resourceCode } = this.detailInfo;
        //step 2: analysis resource
        resourceApi.analysisToResource(resourceCode).then(() => {
          //step 3: get newest config data(newest version)
          resourceApi.getResourceDetailById(this.currentNode.id).then(res => {
            if (res.data) {
              this.detailInfo = res.data;
              this.jsonValue = res.data.content || "";
              //step 4: save config
              afterSourceSave();
            } else {
              this.detailInfo = {};
            }
          });
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
  #source-manage {
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
    .left_tree_box {
      flex: 0 224px;
      width: 224px;
      background-color: #f9f9fb;
      overflow: hidden;
      padding-top: 12px;
      .data_tree {
        margin-top: 16px;
        overflow-y: auto;
        height: calc(100% - 127px);
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
        .el-icon-more {
          transform: rotate(90deg);
        }
      }
      .data_tree::-webkit-scrollbar {
        width: 0 !important;
      }
    }

    .resource_path_setting {
      display: inline-block;
      color: #ffa046;
    }

    .empty_description {
      color: #9ea5b2;
    }

    .right_content {
      flex: 1;
      overflow-y: auto;
      /*height: calc(100vh - 106px);*/
      height: 100%;
      .top_info_box {
        padding: 24px;
        .detail_box {
          display: flex;
          margin-top: 24px;
          line-height: 20px;
          justify-content: center;
          align-items: center;
          .detail_resource_path {
            flex: 1;
          }

          .detail_sort {
            width: 120px;
          }

          .menu_setting {
            margin-left: 40px;
          }
        }
      }

      .split_bar {
        height: 8px;
        width: 100%;
        background-color: #f9f9fb;
      }
      .table_content {
        padding: 24px;
        .search_box {
          // padding-top: 24px;
          margin-bottom: 16px;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
    .before_12::before {
      height: 12px;
    }
    .before_16::before {
      height: 16px;
    }
    .circle_before {
      position: relative;
      display: inline-block;
      padding-left: 10px;
    }
    .circle_before::before {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 8px;
      background-color: #00b259;
    }
    .grey_before::before {
      background-color: #505363;
    }
    .red_before::before {
      background-color: #e60000;
    }
    .plain_button {
      color: #505363;
      background-color: #fff;
    }
    .plain_button:hover {
      color: #00b259;
    }
    .plain_button:focus {
      color: #00b259;
    }
  }
</style>

<style lang="scss">
  #source-manage {
    .self-filter-input {
      margin-bottom: 20px;
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
      .el-input__icon {
        color: #9da5b2;
      }
      .el-input__clear {
        line-height: 32px;
      }
    }

    .el-radio-button {
      margin-top: 0px;
      .el-radio-button__inner {
        padding: 8px 10px;
        width: 88px;
        font-size: 12px;
      }
    }

    // 对话框样式重置
    .source_dialog {
      .el-dialog {
        width: 527px;
        .el-dialog__header {
          padding: 24px 40px 8px 40px;
          .el-dialog__title {
            font-weight: bold;
          }
        }
        .el-dialog__body {
          padding: 6px 40px;
          .suffix_icon {
            width: 14px;
            height: 14px;
            position: relative;
            top: 1px;
            right: 5px;
          }
        }
        .dialog-footer {
          padding: 0px 20px 4px 20px;
          margin-top: 0;
        }
      }
    }

    .code_source_dialog {
      .el-dialog {
        width: 1100px;

        .design-json {
          height: 600px;
          background-color: #fff;
        }
      }
    }
    .init_dialog {
      .el-dialog {
        width: 1006px;
      }
    }
    .delete_dialog {
      .el-dialog {
        width: 428px;
        .el-dialog__header {
          padding-top: 18px;
          padding-bottom: 0;
          .el-dialog__headerbtn {
            position: absolute;
            top: 24px;
            right: 20px;
          }
        }
        .el-dialog__body {
          .warning_title {
            line-height: 22px;
            .before_icon {
              width: 24px;
              height: 22px;
              margin-right: 2px;
              vertical-align: bottom;
            }
          }
          .delete_tips {
            color: #505363;
            line-height: 20px;
            font-size: 14px;
            margin-top: 16px;
            text-indent: 32px;
          }
        }
      }
    }

    .resource_setting_dialog {
      .resource_setting_dialog_title {
        font-size: 15px;
        font-weight: bold;
      }

      .resource_setting_dialog_content {
        margin-left: 25px;
        padding: 0 0 10px;
        line-height: 21px;
      }

      .resource_setting_icon {
        font-size: 20px;
        color: #ffa046;
      }
    }

    .el-button--small {
      padding: 8px 16px;
      box-shadow: none;
    }

    //   重写table样式-小型
    .small_table {
      .el-table {
        th {
          padding: 6px 0;
          height: 36px;
        }
        th:first-child {
          padding-left: 10px;
        }
        .el-input {
          margin-bottom: 0;
          .el-input__inner {
            height: 24px;
            line-height: 24px;
          }
        }
        td {
          padding: 4px 0;
          height: 32px;
        }
        td:first-child {
          padding-left: 10px;
        }
      }
      .el-pagination {
        padding: 0;
        .el-pagination__total {
          height: 24px;
          line-height: 24px;
        }
        button {
          height: 24px;
          line-height: 24px;
          min-width: 24px;
        }
        .el-pager {
          .number {
            height: 24px;
            line-height: 24px;
            min-width: 24px;
          }
        }
        .pagination-jumper {
          height: 24px;
          line-height: 24px;
          input {
            width: 24px;
            height: 24px;
            line-height: 24px;
          }
        }
        .pagination-sizes {
          height: 24px;
          line-height: 24px;
          .pagination-select {
            height: 24px;
            .el-input {
              .el-input__inner {
                height: 24px;
              }
            }
          }
        }
      }
    }
  }
  .resource_popover .el-dropdown-menu__item:hover {
    background-color: #f5f7fa !important;
  }
  .resource_popover {
    .el-dropdown-menu__item span {
      color: #505363;
    }
    .green_hover:hover {
      span {
        color: #00b259;
      }
    }
    .delete_hover:hover {
      span {
        color: #e60000;
      }
    }
  }
</style>
